export default __webpack_public_path__ + "static/bottom-45f3101a79a2b3cda79255e7145df3e0.png";